import type { Node, NodeProps } from "@xyflow/react";

import { FlowNodeCard, FlowNodeRow, LeftTargetHandle } from "./shared";
import type { ProductNodeData } from "./types";

type ProductFlowNode = Node<ProductNodeData, "product">;

export function ProductNode({ data }: NodeProps<ProductFlowNode>) {
  return (
    <>
      <LeftTargetHandle />
      <FlowNodeCard title="Product">
        <p className="text-sm font-semibold">{data.name || "Unknown product"}</p>
        <FlowNodeRow label="Weight" value={typeof data.weight === "number" ? data.weight : "-"} />
        <FlowNodeRow label="Score" value={typeof data.score === "number" ? data.score : "-"} />
      </FlowNodeCard>
    </>
  );
}
